module.exports = __webpack_public_path__ + "451c6062759601067733e8a0bc1c9258.svg";